<template>
    <div class="action-item" @click="$store.state.core.featuresStatus.reading_guide = !$store.state.core.featuresStatus.reading_guide" :class="{active: $store.state.core.featuresStatus.reading_guide}">
        <div class="active-action item" v-if="$store.state.core.featuresStatus.reading_guide">
          <span class="icon-check"></span>
        </div>


        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <div v-html="icons.readGuide"></div>
                  <h3>{{$t('reading guide')}}</h3>

                </div>
            </template>
            <span>{{$t('Display horizontal guide line')}}</span>
        </v-tooltip>

    </div>
</template>


<script>
    import {icons} from '../../utils/icons'
    export default {
        name: "cursor-element",
        data() {
            return {
                active: false,
                icons
            }
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        mounted() {
            this.displayLine()
            document.addEventListener("mousemove", (e)=> {
                if (this.$store.state.core.featuresStatus.reading_guide) {

                    let tempY = e.clientY;

                    if (tempY < 0) {
                        tempY = 0;
                    }
                    document.getElementById('read-guide-line').style.top = tempY + 10 + 'px'
                }
            })
        },
        methods: {
          displayLine() {
            if (this.$store.state.core.featuresStatus.reading_guide) {
              this.$emit('countAnalytics', this.data._id)
              document.getElementById('read-guide-line').classList.add('activeGuideLine')
            } else {
              document.getElementById('read-guide-line').classList.remove('activeGuideLine')
            }
          }
        },
        watch: {
            '$store.state.core.featuresStatus.reading_guide':function () {
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
              this.displayLine()
            }
        }
    }
</script>

<style >
.read-guide-line {
    position: fixed;
    width: 100%;
    background: black;
    height: 8px;
    border-top: 2px yellow solid;
    border-bottom: 2px yellow solid;
    top: 50%;
    z-index: 10000;
    display: none;
    pointer-events: none;
    left: 0;
}
    .activeGuideLine {
        display: block;
    }
</style>
